// extracted by mini-css-extract-plugin
module.exports = {"root":"Carousel_root__Bf4fC","wrapper":"Carousel_wrapper__ey_Ve"};